import client from './client';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

/**
 * @typedef {Object} News
 */

const URL = 'news/';

const fetchNews = async () => {
  return client.get(URL);
};

const fetchSingleNews = async (id: number) => {
  return client.get(URL + id + '/');
};

const actions = {
  fetchNews, fetchSingleNews,
};

export default actions;
